import React, { useEffect, useState } from 'react';
import AddNewAdmin from 'src/components/Admin/AddNewAdmin';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import bluePlusCircleIcon from 'src/assets/svgsResponsive/bluePlusCircleIcon.svg';
import searchIcon from 'src/assets/svgs/searchIcon.svg';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { adminList, adminUpdateStatus } from 'src/services/admin';
import { makeHoursAndMinutes, tokenDecode } from 'src/utils/function';
import SelectBox from 'src/components/Common/SelectBox/SelectBox';
import ResponsiveAdminListAccordion from 'src/components/Responsive/admin/ResponsiveAdminListAccordion';
import blueCancelIcon from 'src/assets/svgsResponsive/blueCancelIcon.svg';
import ConfirmationPopUp from 'src/components/Common/ConfirmationPopUp';
import ModalContentBlock from 'src/components/Common/ModalContentBlock';
import { toaster } from 'src/utils/toaster';
import ResetPassword from 'src/components/Admin/ResetPassword';

const Admin = () => {
    const [addNewAdmin, setAddNewAdmin] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(50);
    const [first, setFirst] = useState(0);
    const [adminListData, setAdminListData] = useState([]);
    const [totalAdminRecords, setTotalAdminRecords] = useState(0);
    const [filterSelectData, setFilterSelectData] = useState({ value: 'yesterday', label: 'Yesterday' });
    const [openAcoordionResponsive, setOpenAcoordionResponsive] = useState<any>(null);
    const [confirnModalOpen, setConfirmModalOpen] = useState(false);
    const [selectedItemStatus, setSelectedItemStatus] = useState<any>(null);
    const [selectedItemId, setSelectedItemId] = useState<any>(null);
    const [userData, setUserData] = useState<any>({});
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [addHourlyCharge, setAddHourlyCharge] = useState(false);

    const getToken = async () => {
        const token = await tokenDecode();
        setUserData(token);
    };
    useEffect(() => {
        getToken();
    }, []);

    const controller = new AbortController();
    const filterOptions = [
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'this_week', label: 'This week' },
        { value: 'this_month', label: 'This month' },
        { value: 'this_year', label: 'This year' },
        { value: 'last_7_days', label: 'Last 7 days' },
        { value: 'last_30_days', label: 'Last 30 days' },
        { value: 'all_time', label: 'All time' },
    ];
    const filterSelectFunction = (data: any) => {
        setFilterSelectData(data);
    };
    const handleRowClick = (row: any) => {
        if (userData?.permissions?.includes('user_update')) {
            setIsUpdate(true);
            setAddNewAdmin(true);
            setSelectedRowData(row.data);
        }
    };
    useEffect(() => {
        if (searchInput) {
            getAdminList(`?page=${page}&limit=${rows}&search=${searchInput}&dataRange=${filterSelectData.value}&orderByColumnName=adminId&ascOrDesc=desc`, controller.signal);
        } else {
            getAdminList(`?page=${page}&limit=${rows}&dataRange=${filterSelectData.value}&orderByColumnName=adminId&ascOrDesc=desc`, controller.signal);
        }
        return () => controller.abort();
    }, [page, rows, searchInput, filterSelectData]);

    const getAdminList = async (url: string, signal?: any) => {
        const adminResData = await adminList(url, signal);
        setAdminListData(adminResData?.data?.data);
        setTotalAdminRecords(adminResData?.data?.total);
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newAdminSuccess = () => {
        if (page === 0) {
            getAdminList(`?page=${page}&limit=${rows}&dataRange=${filterSelectData.value}&orderByColumnName=adminId&ascOrDesc=desc`, controller.signal);
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewAdmin(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };
    const deactivateAdmin: () => Promise<void> = async () => {
        //API call
        let payload = `/${selectedItemId}?isActive=${selectedItemStatus}`;
        const response = await adminUpdateStatus(payload);
        if (response?.data?.status) {
            toaster('success', 'Status Updated successfully.');
        } else {
            toaster('error', 'Unable to update admin status.');
        }
        getAdminList(`?page=${page}&limit=${rows}&dataRange=${filterSelectData.value}&orderByColumnName=adminId&ascOrDesc=desc`, controller.signal);
        setConfirmModalOpen(false);
    };
    const checkBoxChange = async (e: any, id: any) => {
        setSelectedItemId(id);
        if (e.target.checked) {
            setSelectedItemStatus('1');
        } else {
            setSelectedItemStatus('0');
            setConfirmModalOpen(true);
        }
    };
    useEffect(() => {
        if (selectedItemStatus === '1') {
            deactivateAdmin();
        }
    }, [selectedItemStatus]);

    const GetName = (row: any) => <div>{row?.adminFullName}</div>;
    const GetEmail = (row: any) => <div>{row?.adminEmail}</div>;
    const GetAdminAcction = (row: any) => (
        <div>
            <label className="switch" aria-label="Toggle admin active status">
                <input type="checkbox" onChange={(e) => checkBoxChange(e, row?.adminId)} className="is_trending" name="is_trending" data-id={row?.adminId} checked={row?.isActiveAdmin === '1'} />
                <span className="slider round"></span>
            </label>
        </div>
    );
    const GetButton = (row: any) => (
        <div
            onClick={(e) => {
                handleButton({ e, row });
            }}
            className={`h-7 min-w-[130px] py-1  text-white border-2  rounded-lg justify-center items-center inline-flex cursor-pointer bg-primary border-primary `}
        >
            <p className="text-sm font-medium ">Reset password</p>
        </div>
    );
    const handleButton = ({ e, row }: any) => {
        if (e) {
            e.stopPropagation();
        }
        setAddHourlyCharge(true);
        setSelectedRowData(row);
    };
    const GetSpentTime = (row: any) => <div>{makeHoursAndMinutes(Number(row?.total_screening_time_in_min))}</div>;
    const GetJobCreated = (row: any) => <div>{row?.total_jobs_created}</div>;
    const GetJobCompleted = (row: any) => <div>{row?.total_jobs_completed}</div>;
    const GetJobCancelled = (row: any) => <div>{row?.total_jobs_cancelled}</div>;
    const GetRegisterdWorker = (row: any) => <div>{row?.total_employees_created}</div>;
    return (
        <div>
            <div className="lg:hidden flex flex-col md:flex-row gap-3 items-center">
                <div className="w-full">
                    <div className="relative w-full">
                        <input
                            className={`${
                                addNewAdmin ? 'opacity-40' : ''
                            } w-full h-[41px] px-5 py-2 pr-10 bg-white focus-visible:outline-none focus:border focus:border-primary rounded-3xl border border-gray10 placeholder:text-gray20`}
                            placeholder="Search"
                            disabled={addNewAdmin ? true : false}
                            onChange={handleSearch}
                            value={searchInput}
                        />

                        <img className="w-6 h-6 absolute right-3 top-2" src={searchIcon} alt="searchicon" />
                    </div>
                </div>
                <div className="w-full flex flex-row items-center">
                    <div className="dashboard_dropdown w-full !h-[44px] !rounded-lg flex items-center">
                        <SelectBox
                            value={filterSelectData}
                            onChangeFunc={filterSelectFunction}
                            options={filterOptions}
                            isDisabled={addNewAdmin ? true : false}
                            classComp="custom_react_select"
                            menuPlacement="bottom"
                        />
                    </div>
                    {userData?.permissions &&
                        userData?.permissions?.includes('user_create') &&
                        (addNewAdmin ? (
                            <span
                                className="ml-2"
                                onClick={() => {
                                    setAddNewAdmin(false);
                                    setIsUpdate(false);
                                    setSelectedRowData(null);
                                }}
                            >
                                <img src={blueCancelIcon} alt="blueCancelIcon" className="cursor-pointer min-w-[38px] h-[44px] md:min-w-[50px] md:h-[50px] " />
                            </span>
                        ) : (
                            <span className="ml-2" onClick={() => setAddNewAdmin(true)}>
                                <img src={bluePlusCircleIcon} alt="bluePlusCircleIcon" className="cursor-pointer min-w-[38px] h-[44px] md:min-w-[50px] md:h-[50px] " />
                            </span>
                        ))}
                </div>
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewAdmin(false);
                    setIsUpdate(false);
                    setSelectedRowData(null);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewAdmin(true)}
                nextStep={addNewAdmin}
                addNewBtnText={'Add new Admin'}
                isEmploy={true}
                isAdmin={true}
                headerText="Admins"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                setFilterSelectData={setFilterSelectData}
                filterSelectData={filterSelectData}
                isSave={userData?.permissions && userData?.permissions?.includes('user_create')}
            />
            {addNewAdmin && (
                <AddNewAdmin
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newAdminSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewAdmin ? 'hidden' : 'max-lg:block hidden'}`}>
                <>
                    {adminListData?.length === 0 && (
                        <div
                            className=" bg-white max-md:h-10 flex justify-center items-center max-lg:font-semibold
                         max-lg:text-xl max-lg:h-12  max-md:font-medium max-md:text-lg"
                        >
                            No Administrator Found
                        </div>
                    )}
                    <ResponsiveAdminListAccordion
                        adminListData={adminListData}
                        openAcoordionResponsive={openAcoordionResponsive}
                        setOpenAcoordionResponsive={setOpenAcoordionResponsive}
                        handleButton={handleButton}
                        onRowClick={handleRowClick}
                    />
                    <div className="mt-5">
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalAdminRecords}
                            onPageChange={onPageChange}
                            className="datatable_pagination"
                            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        />
                    </div>
                </>
            </div>
            <div className="py-6 hidden lg:block">
                <DataTable value={adminListData} tableClassName="logdatatable admintable" emptyMessage="No Administrator Found" className="" onRowClick={handleRowClick}>
                    <Column field="adminFullName" header="Name" body={GetName}></Column>
                    <Column field="adminEmail" header="Email" body={GetEmail}></Column>
                    <Column field="total_screening_time_in_min" header="Spent Time" body={GetSpentTime}></Column>
                    <Column field="total_jobs_created" header="Jobs Created" body={GetJobCreated}></Column>
                    <Column field="total_jobs_completed" header="Jobs Completed" body={GetJobCompleted}></Column>
                    <Column field="total_jobs_cancelled" header="Jobs Cancelled" body={GetJobCancelled}></Column>
                    <Column field="total_employees_created" header="Workers Registered" body={GetRegisterdWorker}></Column>
                    {userData?.permissions && userData?.permissions?.includes('user_update') && <Column field="adminId" header="Is Active" body={GetAdminAcction}></Column>}
                    {userData?.permissions && userData?.permissions?.includes('user_update') && <Column field="" header="Action" style={{ width: '42px' }} body={GetButton}></Column>}
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalAdminRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
            {confirnModalOpen && (
                <ModalContentBlock onclose={() => setConfirmModalOpen(false)} isMoreClass="logout_modal" isModalOpen={confirnModalOpen}>
                    <ConfirmationPopUp
                        confirmText="Are you sure you want to deactivate this Admin?"
                        submitOnClick={() => {
                            deactivateAdmin();
                        }}
                        cancelOnClick={() => setConfirmModalOpen(false)}
                    />
                </ModalContentBlock>
            )}
            {addHourlyCharge && (
                <div>
                    <ModalContentBlock
                        onclose={() => {
                            setAddHourlyCharge(false);
                        }}
                        isModalOpen={addHourlyCharge}
                        isMoreClass={'!xl:min-w-[40%] !min-w-[30%] '}
                    >
                        <ResetPassword selectedRowData={selectedRowData} setModalOpen={setAddHourlyCharge} isOnSuccess={() => newAdminSuccess()} />
                    </ModalContentBlock>
                </div>
            )}
        </div>
    );
};

export default Admin;
